import { AbstractControl } from '@angular/forms';
import { Injectable } from "@angular/core";

// @dynamic
@Injectable()
export class ValidationService {

	static getErrorMessage(validatorName: string, validatorValue?: any) {
		let config = {
			'required': 'Required',
			'requiredTrue': 'Required',
			'invalidCreditCard': 'Is invalid credit card number',
			'invalidEmailAddress': 'Invalid email address',
			'invalidPassword': 'Password must be at least 6 characters long, has two uppercase letters, at least one lowercase letter, two digits, and one special case letter[!@#$&*]',
			'invalidManager': 'Please select a manager',
			'minlength': `Minimum length ${validatorValue.requiredLength}`
		};

		return config[validatorName];
	}

	static creditCardValidator(AC: AbstractControl) {
		// Visa, MasterCard, American Express, Diners Club, Discover, JCB
		return (AC.value.match(/^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/))
			? null
			: { 'invalidCreditCard': true };
	}

	static emailValidator(AC: AbstractControl) {
		// RFC 2822 compliant regex
		return (AC.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/))
			? null
			: { 'invalidEmailAddress': true };
	}

	static passwordValidator(AC: AbstractControl) {
		// (?=.*[A-Z].*[A-Z])    Ensure string has two uppercase letters
		// (?=.*[a-z]+)          Ensure string has at least lowercase letters
		// (?=.*[0-9].*[0-9])    Ensure string has two digits
		// (?=.*[!@#$&*])        Ensure string has one special case letter
		// .{6,}                 Ensure string is of length 6 and more
		// return (AC.value && AC.value.match(/^(?=.*[A-Z].*[A-Z])(?=.*[a-z]+)(?=.*[0-9].*[0-9])(?=.*[!@#$&*]).{6,}$/))
        return (AC.value && AC.value.match(/^.{6,}$/))
			? null
			: { 'invalidPassword': true };
	}

	static matchPassword(AC: AbstractControl) {
		const password = AC.get('user_password').value;
		const confirmPassword = AC.get('confirm_password').value;
		return (password !== confirmPassword)
			? null
			: { 'invalidMatchPassword': true };
	}

	static managerValidator(AC: AbstractControl) {
		const is_groupmanager = AC.get('is_groupmanager').value;
		const master_user = AC.get('master_user').value;
		const master_username = AC.get('master_username').value;
		if(Boolean(is_groupmanager) && (master_user > 0) && (master_username.length)){
			AC.get('confirmPassword').setErrors( {invalidManager: true} );
		}
		return null;
		// return (Boolean(is_groupmanager) && (master_user > 0) && (master_username.length))
		// 	? null
		// 	: { 'invalidManager': true };
	}
}
